if (!customElements.get('dwil-pro-section')) {
  customElements.define('dwil-pro-section', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.dialog = this.querySelector('[data-pro-dialog]');
      this.addEventListener('click', (event) => this.handleClick(event), { signal });
      if (this.dialog) {
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          this.querySelector('[data-pro-dialog-image]').removeAttribute('src');
          if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        }, { signal });
      }
      const sectionShell = this.closest('.shopify-section') || this;
      sectionShell.addEventListener('shopify:block:select', (event) => {
        const block = event.target.closest('[data-pro-document]');
        if (block && this.contains(block)) this.openCertificate(block.querySelector('[data-pro-certificate]'));
      }, { signal });
    }

    disconnectedCallback() {
      this.returnFocus = null;
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
    }

    handleClick(event) {
      const close = event.target.closest('[data-pro-close]');
      if (close && this.contains(close)) {
        this.dialog?.close();
        return;
      }
      const certificate = event.target.closest('[data-pro-certificate]');
      if (certificate && this.contains(certificate) && this.dialog?.showModal) {
        event.preventDefault();
        this.openCertificate(certificate);
        return;
      }
      const link = event.target.closest('[data-pro-inquiry-link]');
      if (!link || !this.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const anchor = document.getElementById(link.hash.slice(1));
      if (!anchor?.matches('[data-pro-inquiry]')) return;
      const form = anchor.closest('dwil-pro-section')?.querySelector('form');
      if (!form) return;
      event.preventDefault();
      for (const [dataKey, fieldKey] of [['proBusiness', 'business_type'], ['proInterest', 'product_interest']]) {
        const field = form.elements.namedItem(`contact[${fieldKey}]`);
        if (link.dataset[dataKey] && field && !field.value.trim()) {
          field.value = link.dataset[dataKey];
          field.dispatchEvent(new Event('input', { bubbles: true }));
          field.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      anchor.focus({ preventScroll: true });
      anchor.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }

    openCertificate(trigger) {
      if (!trigger || !this.dialog?.showModal) return;
      const img = this.querySelector('[data-pro-dialog-image]');
      img.src = trigger.dataset.image;
      img.alt = trigger.dataset.caption;
      this.querySelector('[data-pro-dialog-caption]').textContent = trigger.dataset.caption;
      this.returnFocus = trigger;
      if (!this.dialog.open) this.dialog.showModal();
    }
  });
}
